import {BaseUrl, HubBaseUrl} from './BaseUrlConst';
import fetch from '../auth/FetchInterceptor'
const JwtAuthService = {}
JwtAuthService.getAPI = function (data,endPoint) {
    return fetch({
        url: `${BaseUrl}${endPoint}`,
        method: 'GET',
        // headers: {
        //     'Accept': '*/*',
        //     'Content-Type': 'application/json',
        // },
        data: data
    });
}
JwtAuthService.postApi = function (data,endPoint) {

    return fetch.post(`${BaseUrl}${endPoint}`, data);
}
JwtAuthService.hubPostApi = function (data,endPoint) {

    return fetch.post(`${HubBaseUrl}${endPoint}`, data);
}
JwtAuthService.updateApi = function (data,endPoint) {

    return fetch.put(`${BaseUrl}${endPoint}`, data);
}
JwtAuthService.deleteApi = function (data,endPoint) {
    return fetch({
        url: `${BaseUrl}${endPoint}`,
        method: 'DELETE',
        data: data
    });
}

export default JwtAuthService